import React from 'react'
import { useCartRedux, useConfirmDialog } from '@hooks'

const CartHeader = () => {
    const { confirm } = useConfirmDialog()
    const { items, clearCart } = useCartRedux()

    const handleClearCart = async () => {
        const isConfirmed = await confirm('Are you sure you want to clear all items from the cart?')
        if (isConfirmed) {
            clearCart()
        }
    }

    return (
        <div className="cart-header">
            {/* <h1 className="cart-header-text">Cart Items</h1> */}
            <p className={`cart-clear-all-text ${items.length === 0 && 'disable'}`} onClick={handleClearCart}>
                Clear All
            </p>
        </div>
    )
}

export default CartHeader
